import { FC } from 'react'
import { SearchSelect, SearchSelectProps } from '@shared/ui'
import { inputClassName, axisInputClassName } from '../styles'
import { selectClassName } from './styles'
import { DS_TYPOGRAPHY_BODY_SM_REGULAR } from '@shared/ui'

export const SRSearchSelect: FC<SearchSelectProps> = ({
  emptyError,
  disabled,
  options,
  name,
  onChange,
  defaultLabel,
  isAxis = false,
}) => {
  return (
    <SearchSelect
      name={name}
      options={options}
      disabled={disabled}
      emptyError={emptyError}
      onChange={onChange}
      classNames={{ inputClassName: `${inputClassName} ${isAxis ? `${DS_TYPOGRAPHY_BODY_SM_REGULAR} ${axisInputClassName}` : ''}`, selectClassName }}
      defaultLabel={defaultLabel}
      isAxis={isAxis}
    />
  )
}
